import React from 'react';

export const GithubSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-19.5"
				y="-646.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#292A2E"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 5.33337C10.1097 5.33337 5.33325 10.2298 5.33325 16.2701C5.33325 21.1022 8.3896 25.2018 12.6278 26.6479C13.1609 26.7492 13.3566 26.4107 13.3566 26.1218C13.3566 25.861 13.3467 24.9995 13.3422 24.0856C10.3746 24.7472 9.74847 22.7952 9.74847 22.7952C9.26325 21.5311 8.56412 21.1949 8.56412 21.1949C7.59632 20.5162 8.63707 20.5301 8.63707 20.5301C9.70819 20.6073 10.2722 21.6571 10.2722 21.6571C11.2236 23.3291 12.7675 22.8457 13.3762 22.5663C13.472 21.8594 13.7484 21.377 14.0535 21.1039C11.6842 20.8273 9.19365 19.8895 9.19365 15.6989C9.19365 14.5048 9.61034 13.5292 10.2927 12.7633C10.1819 12.4878 9.81683 11.3755 10.396 9.86903C10.396 9.86903 11.2917 9.57509 13.3301 10.9901C14.181 10.7478 15.0935 10.6262 16 10.6221C16.9065 10.6262 17.8197 10.7478 18.6722 10.9901C20.7081 9.57509 21.6026 9.86903 21.6026 9.86903C22.1832 11.3755 21.8179 12.4878 21.7071 12.7633C22.3911 13.5292 22.8049 14.5048 22.8049 15.6989C22.8049 19.8995 20.3096 20.8244 17.9344 21.0952C18.317 21.4346 18.6579 22.1001 18.6579 23.1205C18.6579 24.5838 18.6455 25.7616 18.6455 26.1218C18.6455 26.4128 18.8375 26.7539 19.3782 26.6465C23.6141 25.1987 26.6666 21.1006 26.6666 16.2701C26.6666 10.2298 21.8909 5.33337 16 5.33337Z"
				fill="white"
			/>
		</svg>
	);
};
